// ─────────────────────────────────────────────────────────────────────────────
// TourManagerSpotlight, the TM's today/tomorrow operational hero. 1:1 port of
// tour-manager-wiring.js + #tm-spotlight-card hero on CD's spotlight shell. Shows
// the most-relevant show right now + tonight's hotel, next venue, and lobby call.
// The Next-3 tickets / Top merch strip lives below as <TmNext3> (movers slot).
// ─────────────────────────────────────────────────────────────────────────────

import type { CSSProperties, JSX } from 'react';
import { useTourManagerSpotlight } from '../../lib';

function spotlightStyle(photoUrl: string): CSSProperties | undefined {
  if (!photoUrl) return undefined;
  const safe = photoUrl.replace(/["'()\\\s]/g, '');
  return {
    backgroundImage:
      'linear-gradient(135deg,rgba(26,14,13,0.92) 0%,rgba(45,21,24,0.78) 45%,rgba(139,26,43,0.55) 100%),' +
      "url('" + safe + "')",
    backgroundSize: 'cover, cover',
    backgroundPosition: 'center, center',
    backgroundRepeat: 'no-repeat, no-repeat',
  };
}

export interface TourManagerSpotlightProps {
  readonly photoUrl?: string;
}

export function TourManagerSpotlight({ photoUrl = '' }: TourManagerSpotlightProps): JSX.Element {
  const { data } = useTourManagerSpotlight();
  const hasPhoto = !!photoUrl;
  const cardClass = 'spotlight' + (hasPhoto ? ' spotlight--has-photo' : '');

  return (
    <article className={cardClass} id="tm-spotlight-card" style={spotlightStyle(photoUrl)}>
      {!hasPhoto && <div className="spotlight__bg" aria-hidden="true"></div>}

      <header className="spotlight__head">
        <div>
          <p className="spotlight__eyebrow">{data.eyebrow}</p>
          <h2 className="spotlight__title disp">{data.title}</h2>
          <p className="spotlight__sub">{data.sub}</p>
        </div>
      </header>

      <div className="spotlight__stats">
        <div className="statile">
          <p className="statile__label">Guarantee</p>
          <p className="statile__value">{data.guarantee}</p>
        </div>
        <div className="statile">
          <p className="statile__label">Tonight's lodging</p>
          <p className="statile__value statile__value--sm">{data.hotel}</p>
        </div>
        <div className="statile">
          <p className="statile__label">Next venue</p>
          <p className="statile__value statile__value--sm">{data.next}</p>
        </div>
      </div>
    </article>
  );
}
